export const SEARCH_SECTION_PRIORITY_OFFSET_STRENGTH = 10e3;
